import { theme } from '@aloft/toolkit-sui';
import { CHART_FONT_FAMILY } from '../consts.ts';

type LegendItemProps = {
  color: string;
  label: string;
  rightX: number;
  y: number;
};

export const LegendItem = ({ color, label, rightX, y }: LegendItemProps) => (
  <g>
    <line x1={rightX - 80} y1={y} x2={rightX - 60} y2={y} stroke={color} strokeWidth={3} />
    <text
      x={rightX}
      y={y}
      fontSize={12}
      fontFamily={CHART_FONT_FAMILY}
      fill={theme.colors.graphNeutral}
      dominantBaseline="middle"
      textAnchor="end"
    >
      {label}
    </text>
  </g>
);
